import { Mail } from "lucide-react";

export default function SignupsTab(props) {
  const { email, subs } = props;
  return (
          <div className="border border-zinc-800" data-testid="admin-table">
            <div className="grid grid-cols-12 gap-4 px-6 py-4 border-b border-zinc-800 font-mono text-[10px] uppercase tracking-[0.2em] text-[#52525B]">
              <span className="col-span-5">Email</span><span className="col-span-3">Code</span><span className="col-span-2">Source</span><span className="col-span-2 text-right">Date</span>
            </div>
            {subs.length === 0 && <p className="p-8 text-center font-mono text-sm text-[#52525B]" data-testid="admin-empty">No signups yet.</p>}
            {subs.map((s) => (
              <div key={s.id} className="grid grid-cols-12 gap-4 px-6 py-4 border-b border-zinc-900 items-center hover:bg-[#0C0C0C] transition-colors" data-testid="admin-row">
                <span className="col-span-5 flex items-center gap-2 truncate"><Mail size={14} color="#D4AF37" /> {s.email}</span>
                <span className={`col-span-3 font-mono text-xs ${s.welcome_code_used ? "text-[#52525B] line-through" : "text-emerald-400"}`}>{s.welcome_code}</span>
                <span className="col-span-2 font-mono text-xs text-[#A1A1AA]">{s.source}</span>
                <span className="col-span-2 text-right font-mono text-xs text-[#71717A]">{new Date(s.created_at).toLocaleDateString()}</span>
              </div>
            ))}
          </div>
  );
}
